import React, { Component } from 'react'
import classNames from 'classnames'
import memoize from 'memoize-one'

import CheckboxTree from 'react-checkbox-tree'

export default
class CheckboxTreeField extends Component {

	state = {
		expanded: [],
	}

	mergeSorted(sorted, toAdd) {
		for(const [key, value] of Object.entries(toAdd)) {
			sorted[key] = [ ...sorted[key], ...value ];
		}
		return sorted;
	}

	_sortSelected = (checked, tree) => {
		const { nodes, field } = this.props;
		const sorted = {
			checked: [],
			unchecked: [],
			disabled: [],
		};
		tree = tree ? tree : nodes;

		for(const node of tree) {
			if(node.children) {
				const childSorted = this._sortSelected(checked, node.children);
				this.mergeSorted(sorted, childSorted)
			}
			else if(node.disabled === true) {
				sorted.disabled.push(node.value);
			}
			else {
				sorted[ field.value.includes(node.value) ? 'checked' : 'unchecked'].push(node.value);
			}
		}

		return sorted;
	}

	sortSelected = memoize(this._sortSelected);

	selectAll = () => {
		const { form, field } = this.props;
		const sorted = this.sortSelected(field.value);
		const all = [ ...sorted.checked, ...sorted.unchecked, ...sorted.disabled ];
		form.setFieldValue(field.name, all);
	};

	deselectAll = () => {
		const { form, field } = this.props;
		const sorted = this.sortSelected(field.value);
		form.setFieldValue(field.name, sorted.disabled);
	};

	render() {
		const { field, form, nodes } = this.props;
		const sorted = this.sortSelected(field.value);

		return (
			<div>
				<CheckboxTree
					nodes={nodes}
					checked={field.value}
					expanded={this.state.expanded}
					onCheck={checked => form.setFieldValue(field.name, checked)}
					onExpand={expanded => this.setState({ expanded })}
					showNodeIcon={false}
					optimisticToggle={false}
				/>
				<div className="CheckboxTree-buttons">
					<button 
						type="button" 
						className={classNames('button-link', { disabled: !sorted.unchecked.length })}
						onClick={this.selectAll}
					>Select all</button>
					<span> / </span>
					<button 
						type="button" 
						className={classNames('button-link', { disabled: !sorted.checked.length })}
						onClick={this.deselectAll}
					>Deselect all</button>
				</div>
			</div>
		)
	}

}


// WEBPACK FOOTER //
// ./src/modules/form/components/input/CheckboxTree.jsx